export default __webpack_public_path__ + "static/media/neha bhadu.8130007d.jpeg";